<!--
     <MetricEditCategory
       readonly
     />

     Public methods:
       set_value(config) // config = {categories: {name: 'My cat', percentage: 25}}
       get_value() → returns config ↑↑↑

     Events:
       change(new_config)
-->

<template>
  <div class="mec-cont">

    <div class="mec-list" :key="last_catid">
      <div class="mec-row" v-for="catid, index in catid_array" :key="catid">
        <div class="mec-index">
          {{ index + 1 }}
        </div>

        <v-text-field
          :value="cats[catid].name"
          :ref="'name_' + catid"
          :label="$vuetify.lang.translator('labels.name')"
          :placeholder="$vuetify.lang.translator('indicators.new_measure')"
          :rules="[rule_required]"
          :readonly="readonly"
          type="text"
          :class="'mec-input ' + (readonly ? 'qmkey-form-input-readonly' : 'qmkey-form-input required')"
          outlined
          dense
          background-color="#f2f2f2"
          :disabled="readonly"
          maxlength="64"
          @input="value => update_cat_name(catid, value)"
        />

        <v-text-field
          :value="''+cats[catid].percentage"
          :ref="'percentage_' + catid"
          :label="$vuetify.lang.translator('indicators.percentage')"
          size="8"
          placeholder="%"
          :rules="[rule_required, rule_percentage]"
          :readonly="readonly"
          type="number"
          :class="'mec-input ' + (readonly ? 'qmkey-form-input-readonly' : 'qmkey-form-input required')"
          outlined
          dense
          background-color="#f2f2f2"
          :disabled="readonly"
          maxlength="12"
          @input="value => update_cat_percentage(catid, value)"
        />

        <v-btn @click="del_category(catid)">x</v-btn>
      </div>
    </div>

    <v-btn color="primary" @click="add_category">{{ $vuetify.lang.translator('add') }}</v-btn>
  </div>
</template>

<style lang="scss">
 @import "@/sass/variables.scss";

 .mec-cont {
   width: 100%;
   display: flex;
   flex-direction: column;
   padding: 8px;
 }

 .mec-list {
   display: flex;
   flex-direction: column;
   width: 100%;
   gap: 24px;
   padding-bottom: 24px;
 }

 .mec-row {
   display: flex;
   flex-direction: row;
   align-items: center;
   justify-content: space-between;
 }

 .mec-index {
   width: 64px;
   text-align: right;
   padding-right: 24px;
 }

 .mec-input {
   max-height: 48px;
 }
</style>

<script>
 export default {
   name: 'MetricEditCategory',

   props: [
     'readonly',
     'value'
   ],

   data: () => ({
     catid_array: [], // [catid]
     last_catid: 0,
     cats: {}, // {catid: {name: 'name', percentage: 69}}
   }),

   computed: {
   },

   mounted() {
    if (this.value) {
      this.set_value(this.value)
    }
   },

   methods: {
     get_value() {
       return this.serialize();
     },

     set_value(config) {
       const sorted_cats = Object.entries(config.categories || {});
       sorted_cats.sort((a, b) => a[1] - b[1])
       this.cats = {};
       for (const [name, percentage] of sorted_cats) {
         this.cats[++this.last_catid] = {'name': name, 'percentage': percentage};
       }
       this.catid_array = [...Array(sorted_cats.length).keys().map(i => i+1)];
     },

     add_category() {
       this.catid_array.push(++this.last_catid);
       this.cats[this.last_catid] = {
         name: '',
         percentage: 0,
       };
       console.log('*********', this.cats, '*********', this.catid_array);
     },

     del_category(catid) {
       this.catid_array.splice(this.catid_array.indexOf(catid), 1);
       delete this.cats[catid];
     },

     update_cat_name(catid, value) {
       this.cats[catid].name = value;
       this.update()
     },

     update_cat_percentage(catid, value) {
       this.cats[catid].percentage = value;
       this.update()
     },

     update() {
      this.$emit('input',this.get_value())
     },

     serialize() {
       const res = {};
       for (const cat of Object.values(this.cats)) {
         res[cat.name] = +cat.percentage;
       }
       return {
         'categories': res,
       };
     },

     rule_required(value) {
       // TODO: Multilang: Change hardcoded string
       return !!value || this.$vuetify.lang.translator('required_field')
     },

     rule_percentage(value) {
       return (value <= 100 && value >= 0) || this.$vuetify.lang.translator('indicators.invalid_percentage');
     },
   },
 }
</script>
